import { Component, Input, OnInit } from '@angular/core';
import { OrderStatusCountModel } from '../../../models/rest/customer/order-status-count.model';

@Component({
    selector: 'app-order-status-counts-widget',
    templateUrl: './order-status-counts-widget.component.html',
    styleUrls: ['./order-status-counts-widget.component.css']
})
export class OrderStatusCountsWidgetComponent implements OnInit {

    @Input() orderStatusCounts: OrderStatusCountModel[];

    constructor() { }

    ngOnInit() {
    }

}














